import { ITALY_REGION_ID, ITALY_REGION_NAME_TO_CODE } from '../constants';

export const getIsItalyRegionId = (regionId?: string) =>
  regionId === ITALY_REGION_ID;

export const parseItalianState = (state: string) =>
  ITALY_REGION_NAME_TO_CODE[state] ?? state;
